// 3rd Party
import { Dispatch } from 'redux';
import { createAction } from 'redux-actions';

// Utility References
import { IAjaxInfo, IApiProgressFunctions } from 'Utility';
import { Handler } from 'Utility/IndexOfActions';
import { Notification } from 'Utility/IndexOfServices';

import { Actions } from 'App/Models/Base/Actions';

// App References
import {
    AllExceptionNotifier,
    IApiChangePasswordViewModel as IViewModel
} from 'App/IndexOfInterfaces';
import { UserApi} from 'App/IndexOfServices';

// State
import { IChangePasswordState as IState } from './State';

// Model References
import { ChangePasswordActionTypes as ActionTypes } from './Models';

interface IActions {
    clear: Handler.Action;
    submit: Handler.Action1<IViewModel>;
    receiveChangePassword: Handler.Action1<IViewModel>;
}

class ChangePasswordActions extends Actions {

    constructor(apiProgressFunctions: IApiProgressFunctions, public allExceptionNotifier: Handler.Action1<IAjaxInfo>){
        super(apiProgressFunctions);
    }

    public clear = createAction(ActionTypes.reset.resetForm);

    public receiveChangePassword = createAction(
        ActionTypes.receive.changePassword, (viewModel: IViewModel) => viewModel
    );

    public submit = (viewModel: IViewModel) => (dispatch: Handler.AnyForDispatch): void => {

        const onSuccess = () => {

            Notification.success.importantRecordUpdated('Your password has been changed.', 'Password Changed');

            dispatch(this.clear());
        };

        this.api.callWithPayload(UserApi.changePassword(), viewModel, onSuccess, this.allExceptionNotifier);
    }
}

const actionsFactory = (dispatch: Dispatch<IState>, progressFunctions: IApiProgressFunctions): IActions => {

    const notitifationsTitle = 'Change Password';
    const actions = new ChangePasswordActions(progressFunctions, AllExceptionNotifier(notitifationsTitle));

    return {
        clear: () => {
            dispatch(actions.clear());
        },
        receiveChangePassword: (viewModel: IViewModel) => {
            dispatch(actions.receiveChangePassword(viewModel));
        },
        submit: (viewModel: IViewModel) => {
            dispatch(actions.submit(viewModel));
        }
    };
};

export {
    actionsFactory as ChangePasswordActionsDispatcherFactory,
    IActions as IChangePasswordActions
};
